import {BankAccountDomain} from '@dms/api/base';

import {buildArray} from 'shared/web';

/**
 * Returns the bank-account domains the tenant is licensed for, in display order.
 * SALES maps to the sales module, AFTS to the workshop (after-sales) module.
 */
export function getLicensedBankAccountDomains(
  isSalesModuleEnabled: boolean,
  isWorkshopModuleEnabled: boolean
): BankAccountDomain[] {
  return buildArray<BankAccountDomain>([])
    .when(isSalesModuleEnabled, 'SALES')
    .when(isWorkshopModuleEnabled, 'AFTS');
}
